var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-box", class: _vm.videoClass }, [
    _c(
      "video",
      _vm._g(
        _vm._b({ ref: "video" }, "video", _vm.$attrs, false),
        _vm.$listeners
      )
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }